export const filter_number = (val : string) => {
    return val ? val.replace(/[^0-9]/g, '') : ''
}
